import * as React from 'react';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { IVariantsProps } from '../../../../model';
import { Container } from '../../variantsStyled';

import { isPriceSame } from './isPriceSame';
import { VariantList } from './styled';
import { VariantThumbnail } from './VariantThumbnail';

export const VariantsThumbnail: React.FC<IVariantsProps> = ({
  locale,
  selectedId,
  variants,
  currency,
}) => {
  const samePrice = isPriceSame(variants);
  const newDesign = useNewPdDesignEnabled();
  const variantsCount = variants.length;

  return (
    <Container id="pdVariantsThumbnail" newDesign={newDesign}>
      <VariantList newDesign={newDesign} itemsCount={variantsCount}>
        {variants.map((item) => (
          <VariantThumbnail
            variantsCount={variantsCount}
            item={item}
            locale={locale}
            unit={item.parameters?.unit}
            isSelected={item.webId === selectedId}
            currency={currency}
            key={item.webId}
            displayPrice={!samePrice}
          />
        ))}
      </VariantList>
    </Container>
  );
};
